import React from 'react';
import { StarIcon } from 'lucide-react';
const reviews = [{
  name: 'Mark T.',
  text: 'They managed to get out pet stains I thought were permanent. Highly recommend their services!'
}, {
  name: 'Sarah W.',
  text: 'Prompt, professional, and my tile floors look brand new again. Will definitely use them next year.'
}, {
  name: 'David L.',
  text: 'Great communication and fair pricing. The technician was very polite and efficient.'
}];
export function TestimonialsSection() {
  return <section id="reviews" className="relative py-16 md:py-24" data-id="element-166">
      {/* Parallax Background */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1556910103-1c02745a872f?auto=format&fit=crop&q=80")',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-167">
        {/* Dark Navy Overlay */}
        <div className="absolute inset-0 bg-white/90" data-id="element-168" />
      </div>

      <div className="relative z-10 container mx-auto px-4 max-w-6xl" data-id="element-169">
        {/* Section Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-8" data-id="element-170">
          What Our Customers Say
        </h2>

        {/* Featured Review */}
        <div className="flex flex-col items-center text-center mb-6" data-id="element-171">
          {/* Google Logo */}
          <svg className="mb-3" width="40" height="40" viewBox="0 0 48 48" data-id="element-172">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" data-id="element-173" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" data-id="element-174" />
            <path fill="#FBBC05" d="M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.01 24.01 0 0 0 0 21.56l7.98-6.19z" data-id="element-175" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" data-id="element-176" />
          </svg>

          {/* Stars */}
          <div className="flex items-center gap-1.5 mb-3" data-id="element-177">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-red fill-red" size={24} data-id="element-178" />)}
          </div>

          {/* Featured Quote */}
          <p className="text-lg md:text-2xl text-navy font-light italic max-w-3xl leading-relaxed mb-3" data-id="element-179">
            &ldquo;Couldn&apos;t be happier with the exceptional carpet cleaning
            results and competitive prices. The technician treated my home with
            respect and went above and beyond. That kind of service in this
            industry is few and far between.&rdquo;
          </p>

          {/* Attribution */}
          <p className="text-red font-bold text-base" data-id="element-180">
            — Colleena C., Phoenix, AZ
          </p>
        </div>

        {/* Smaller Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-181">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-lg p-6 md:p-8 shadow-xl" data-id="element-182">
              <div className="flex gap-1 mb-4" data-id="element-183">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-red fill-red" size={16} data-id="element-184" />)}
              </div>
              <p className="text-gray-700 mb-4 italic" data-id="element-185">"{review.text}"</p>
              <p className="text-navy font-bold text-sm uppercase tracking-wider" data-id="element-186">
                {review.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}